// Resolve the in-app route that actions a given notification.
//
// Producers should set `metadata.action_url` explicitly (the canonical source).
// As a safety net we also derive a route from the notification `kind`, so a
// notification whose producer predates the action_url convention — or forgets
// it — still deep-links to the right screen on click instead of dead-ending.
//
// Returns null when there is nowhere meaningful to send the user (the click
// then just marks the notification read, as before).
export function notificationRoute(
    metadata: Record<string, unknown> | null | undefined
): string | null {
    if (!metadata) return null;

    const explicit = metadata.action_url;
    if (typeof explicit === 'string' && explicit.length > 0) return explicit;

    switch (metadata.kind) {
        case 'expense_review':
            return '/expenses?review=1';
        case 'payment_received':
        case 'payment_due':
        case 'payment_overdue':
            return '/invoices';
        // Quote decisions carry action_url from the RPC, so this is the safety
        // net for rows written before that landed — they still open the quote
        // rather than dead-ending on a read receipt.
        case 'quote_accepted':
        case 'quote_declined': {
            const quoteId = metadata.quote_id;
            return typeof quoteId === 'string' && quoteId.length > 0
                ? `/workshop?tab=quotes&quote=${quoteId}`
                : '/workshop?tab=quotes';
        }
        default:
            return null;
    }
}
